import {CardVariantType, DataStatus} from 'platform/components';

import {useEffect, useState} from 'react';

import {isNil} from 'ramda';

import {useGetMetadaNoteQuery, usePutMetadaNoteMutation} from '@dms/api/core';
import {EntityResourceIds} from '@dms/api/shared';
import {handleApiError} from '@dms/shared';

import {Nullish, TestIdProps, useDebouncedValue} from 'shared/web';

import {MetadaNoteCard} from './MetadaNoteCard';

interface MetadaNoteWidgetProps extends TestIdProps {
  resourceId: EntityResourceIds;
  contextId: string;
  context: 'COMMENTS_INTERNAL_NOTE';
  title?: string;
  cardVariant?: CardVariantType;
  isEditable?: boolean;
}

export function MetadaNoteWidget(props: MetadaNoteWidgetProps) {
  const [changeNote, setChangeNote] = useState<string | Nullish>();
  const debouncedChangeNote = useDebouncedValue(changeNote, 400);

  const {data: note, isLoading: isNoteLoading} = useGetMetadaNoteQuery({
    contextTarget: 'SERVICE_ORDER',
    contextId: props.contextId,
    context: props.context,
  });

  const [updateNote, {isLoading: isUpdateLoading}] = usePutMetadaNoteMutation();

  useEffect(
    function saveDebouncedNote() {
      if (isNil(debouncedChangeNote)) {
        return;
      }

      updateNote({
        contextTarget: 'SERVICE_ORDER',
        contextId: props.contextId,
        context: props.context,
        body: {
          text: debouncedChangeNote,
        },
      })
        .unwrap()
        .then()
        .catch(handleApiError);
    },
    [debouncedChangeNote, props.resourceId, props.contextId, props.context, updateNote]
  );

  return (
    <DataStatus isLoading={isNoteLoading}>
      <MetadaNoteCard
        cardVariant={props.cardVariant}
        note={note?.text}
        title={props.title}
        onChange={(values) => setChangeNote(values?.note)}
        isLoading={isUpdateLoading}
        data-testid={props['data-testid']}
        isDisabled={!props.isEditable}
      />
    </DataStatus>
  );
}
